import { TextFieldTheme } from '@wix/wix-ui-tpa/cssVars';
import React, { useCallback, useEffect, useState } from 'react';
import { EXPERIMENTS } from '../../constants/experiments';
import { useExperiments } from '../../contexts/experiments-context';
import { useFieldAttributes } from '../../sdk/components';
import { FieldDescriptionWUT, FieldErrorWUT, FieldLabelWUT } from '../../sdk/components-wut';
import { AutocompleteWUT } from '../autocomplete/autocomplete-wut';
import { useInvokeCallback } from '../shared/use-invoke-callback';
export const DropdownAutocompleteWUT = ({ id, target, options, placeholder, required, hideLabel, value, disabled, description, hasError = false, errorMessage, error, label, onChange, onBlur, onFocus, FieldLayout, requiredIndicatorType, requiredIndicatorPlacement })=>{
    const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
    const [inputValue, setInputValue] = useState(()=>resolveLabel(options, value));
    const { isExperimentEnabled } = useExperiments();
    const useFloatingUI = isExperimentEnabled(EXPERIMENTS.FLOATING_MULTILINE_ADDRESS_DROPDOWNS);
    const selectedLabel = resolveLabel(options, value);
    useEffect(()=>{
        if (useFloatingUI) {
            setInputValue(selectedLabel);
        }
    }, [
        useFloatingUI,
        selectedLabel,
        value
    ]);
    const invokeBlur = useInvokeCallback(onBlur);
    const handleBrowserAutofill = useCallback((currentInputValue)=>{
        const matchingOption = findMatchingOption(options, currentInputValue);
        if (matchingOption) {
            const newValue = String(matchingOption.id);
            onChange?.(newValue);
        }
    }, [
        onChange,
        options
    ]);
    const handleChange = useCallback((event)=>{
        handleBrowserAutofill(event.target.value);
        setInputValue(event.target.value);
    }, [
        setInputValue,
        handleBrowserAutofill
    ]);
    const handleSelect = useCallback((option)=>{
        const newValue = option.id;
        setInputValue(option.value);
        onChange(newValue);
    }, [
        onChange,
        setInputValue
    ]);
    const handleBlur = useCallback(()=>{
        const currentLabel = resolveLabel(options, value);
        setInputValue(currentLabel);
        invokeBlur();
    }, [
        invokeBlur,
        value,
        options
    ]);
    const handleManualInput = useCallback(()=>{
        const matchingOption = findMatchingOption(options, inputValue);
        if (matchingOption) {
            const newValue = String(matchingOption.id);
            onChange?.(newValue);
            setInputValue(matchingOption.value);
        }
        if (!inputValue) {
            onChange?.('');
            setInputValue('');
        }
    }, [
        options,
        inputValue,
        onChange
    ]);
    const handleInitialSelectedOptionsSet = useCallback(()=>{
        const currentLabel = resolveLabel(options, value);
        setInputValue(currentLabel);
    }, [
        options,
        value
    ]);
    return /*#__PURE__*/ React.createElement(FieldLayout, {
        fieldId: id,
        renderLabel: ()=>/*#__PURE__*/ React.createElement(FieldLabelWUT, {
                labelId: labelId,
                htmlFor: inputId,
                required: required,
                label: label,
                hideLabel: hideLabel,
                requiredIndicatorType: requiredIndicatorType,
                requiredIndicatorPlacement: requiredIndicatorPlacement
            }),
        renderInput: ()=>/*#__PURE__*/ React.createElement(AutocompleteWUT, {
                useFloatingUI: useFloatingUI,
                id: inputId,
                value: inputValue,
                options: options,
                disabled: disabled,
                showArrow: true,
                placeholder: placeholder,
                error: hasError,
                initialSelectedId: value ?? undefined,
                onInitialSelectedOptionsSet: handleInitialSelectedOptionsSet,
                onChange: handleChange,
                onSelect: handleSelect,
                onManualInput: handleManualInput,
                onBlur: handleBlur,
                onFocus: onFocus,
                ariaDescribedBy: ariaDescribedBy,
                theme: TextFieldTheme.Box,
                portalDataHook: `dropdown-portal-${target}`
            }),
        renderDescription: ()=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FieldErrorWUT, {
                target: target,
                hasError: hasError,
                errorMessage: errorMessage,
                id: errorId
            }), /*#__PURE__*/ React.createElement(FieldDescriptionWUT, {
                description: description,
                id: descriptionId
            }))
    });
};
function resolveLabel(options, value) {
    if (!value) {
        return '';
    }
    return options.find((option)=>option.id === value)?.value ?? '';
}
function findMatchingOption(options, label) {
    return options.find((option)=>option.value.toLocaleLowerCase() === label.toLocaleLowerCase().trim());
}

//# sourceMappingURL=dropdown-autocomplete-wut.js.map